export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getAll: state => state.items,
    getByAgency: state => agency => state.items.filter(item => item.agency.id == agency),
    getByAgencyNumber: state => agency => state.items.filter(item => item.agency.internal_number == agency),
    getByStatusSlug: state => status => state.items.filter(item => item.status_slug == status || item.status.status_slug == status),
    getByAgencyNumberAndStatusSlug: state => ({agency, status}) => state.items.filter(item => item.agency.internal_number == agency && (item.status_slug == status || item.status.status_slug == status)),
    getItem: state => id => state.items.find(item => item.id == id)
  },
  actions: {
    /**
    * Charge tous les items via l'API dans le state. Si des données sont déjà présentes dans le state, le résolve() est lancé de suite
    * @param   {boolean} wait  Si wait = true, on attends vraiment que les données soient reçues pour lancer le resolve() (impératif pour charger un formulaire de modification)
    * @returns {promise}       Aucune donnée n'est retournée
    */
   getAll: (context, wait = false) => {
     let params = {
       wait: wait,
       api_url: 'employee',
       api_data_path: 'employees',
       namespace: 'employee'
     }
     return context.dispatch('getAll', params, {
       root: true
     })
   },
    /**
     * Charge tous les items via l'API dans le state avec des données limitées. Si des données sont déjà présentes dans le state, le résolve() est lancé de suite
     * @param   {boolean} wait  Si wait = true, on attends vraiment que les données soient reçues pour lancer le resolve() (impératif pour charger un formulaire de modification)
     * @returns {promise}       Aucune donnée n'est retournée
     */
    getAllForSelect: (context, wait = false) => {
      let params = {
        wait: wait,
        api_url: 'employee/index/simple',
        api_data_path: 'employees',
        namespace: 'employee'
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    },
    /**
     * Recherche serveur d'employés, pour l'autocomplete « Responsable ». La table dépasse
     * 46 000 fiches : les écrans qui n'ont pas besoin de la liste entière ne la chargent pas.
     * @param   {string}  search      Chaîne recherchée (nom, prénom, matricule, GID)
     * @param   {boolean} add         true pour compléter le state au lieu de le remplacer
     * @returns {promise}
     */
    getAllForSelectBySearch: (context, { wait = false, search, add = true }) => {
      let params = {
        wait: wait,
        api_url: 'employee/index/simple',
        api_data_path: 'employees',
        namespace: 'employee',
        query: 'search=' + encodeURIComponent(search),
        add: add
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    },
    /**
     * Charge des employés par identifiants : sert à réafficher un filtre restauré depuis
     * l'URL, dont l'employé n'est pas forcément déjà dans le state.
     * @param   {array}   ids   Identifiants employés
     * @param   {boolean} add   true pour compléter le state au lieu de le remplacer
     * @returns {promise}
     */
    getAllForSelectByIds: (context, { wait = false, ids, add = true }) => {
      if (!ids || !ids.length) {
        return Promise.resolve()
      }
      let params = {
        wait: wait,
        api_url: 'employee/index/simple',
        api_data_path: 'employees',
        namespace: 'employee',
        query: 'ids=' + ids.join(','),
        add: add
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    },
    getItem: (context, {
      id,
      wait = false
    }) => {
      let params = {
        wait: wait,
        api_url: 'employee',
        namespace: 'employee',
        id: id
      }
      return context.dispatch('getItem', params, {
        root: true
      })
    },
    addItem(context, item) {
      let params = {
        api_url: 'employee',
        namespace: 'employee',
        item: item
      }
      return context.dispatch('addItem', params, {
        root: true
      })
    },
    saveItem(context, item) {
      let params = {
        api_url: 'employee',
        namespace: 'employee',
        item: item
      }
      return context.dispatch('saveItem', params, {
        root: true
      })
    },
    deleteItem(context, id) {
      let params = {
        api_url: 'employee',
        namespace: 'employee',
        id: id
      }
      return context.dispatch('deleteItem', params, {
        root: true
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/modules/employee.js